/**
 * ReportNCContext — aides NON-composants du signalement de non-conformité
 * (contexte, type de valeur, hook d'accès), sorties dans ce module frère : Fast
 * Refresh n'opère que si un fichier n'exporte QUE des composants.
 */

import { createContext, useContext } from 'react'

import type { PendingNCReport } from './ReportNCContext'

export interface ReportNCContextValue {
    openReportNC: (report: PendingNCReport) => void
}

const noop = () => {}

export const ReportNCContext = createContext<ReportNCContextValue | null>(null)

/** Accès à l'ouverture de signalement. Sûr hors provider (no-op). */
export function useReportNC(): ReportNCContextValue {
    return useContext(ReportNCContext) ?? { openReportNC: noop }
}
